import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Button, Typography } from "antd";

import { DaytimeTouristContext } from "./context-form";
import DropDownFormList from "~v2/components/DropDownFormList/DropdownFormList";

import { filteringCountry } from "../../../helpers/filterCountry";
import { COLORS } from "~constants";

const { Paragraph } = Typography;

const DaytimeTouristNonPH = () => {
  const filteredCountry = filteringCountry();
  const [failed, setisFailed] = useState(false);
  let { isFailed } = useContext(DaytimeTouristContext);

  useEffect(() => {
    setisFailed(isFailed);
  }, [isFailed]);

  return (
    <>
      {failed && (
        <Row justify="center" align="center">
          <Paragraph type="danger">
            <b>Error Submitting Report:</b>
            &nbsp;Please check input fields and make sure you didn't miss
            anything!
          </Paragraph>
        </Row>
      )}
      <DropDownFormList
        formListName="nonPhResident"
        dropdownTitle="Select Country of Residence"
        dropdownList={filteredCountry}
        dropdownName="country"
        dropdownRuleMessage="Please select a country!"
        inputFields={[
          {
            name: "male",
            message: "Please input number of male",
          },
          {
            name: "female",
            message: "Please input number of female",
          },
        ]}
      />
      <Row style={{ marginBottom: 50 }}>
        <Col span={12}>
          <Button
            size="large"
            htmlType="reset"
            style={{ backgroundColor: COLORS.blue1 }}
          >
            Reset
          </Button>
        </Col>
        <Col span={12} style={{ justifyContent: "flex-end", display: "flex" }}>
          <Button
            size="large"
            htmlType="submit"
            style={{ backgroundColor: COLORS.orange }}
          >
            Save
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default DaytimeTouristNonPH;
